import React, {useState} from "react";
import "../../index.css";
import { useMediaQuery } from "@mui/material";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { useQuery } from "@tanstack/react-query";
import * as service from "../../utils/Services";
import { newsQuery } from "../../utils/Querys";
import NewMobile from "../newsComponents/NewMobile";
import LoadingSpinner from "../../components/LoadingSpinner";

const News = () => {
  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
      slidesToScroll: 1,
      align: "start",
      containScroll: "trimSnaps",
    },
    [Autoplay({ delay: 15000 })]
  );
  const phoneView = useMediaQuery("(max-width:800px)");
  const tabletView = useMediaQuery("(max-width:960px)");
  const maxHeight = phoneView && tabletView ? "350px" : "500px";
  const newsQueryVar = newsQuery();
  const openState = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);


  if (newsQueryVar.isLoading) {
    return <LoadingSpinner />;
  }

  if (newsQueryVar.isError) {
    return <div>Error fetching data</div>;
  }

  const embla = {
    overflow: "hidden",
  };

  const emblaContainer = {
    display: "flex",
    touchAction: "pan-y pinch-zoom",
    
  };

  return (
    <>
      {newsQueryVar.data && newsQueryVar.data.length > 0 ? (
        <div style={embla} ref={emblaRef}>
          {!phoneView && !tabletView ? (
            <div style={emblaContainer}>
              {newsQueryVar.data.map((topic) => {
                return (
                  <div
                    style={{
                      transform: "translate3d(0, 0, 0)",
                      flex: "0 0 100%",
                      minWidth: "0",
                      display: "flex",
                    }}
                  >
                  <div
                    key={topic.id}
                    style={{
                      width:"100%",
                      maxHeight: maxHeight,
                      height: maxHeight,
                      backgroundImage: `url(${topic.event_image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center center",
                    }}
                  />  
                    
                  
                    <div
                      style={{
                        fontSize: "25px",
                        textAlign: "center",
                        fontFamily: "indie flower",
                        width:"100%",
                        margin:"auto",
                        maxHeight: maxHeight,
                        marginLeft:"5%",
                        marginRight:"5%",
                        position:"relative",
                        overflow:"scroll",
                        userSelect:"none"
                      }}
                    >
                      <h3>{topic.title}</h3>
                      {topic.announcement}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={emblaContainer}>
              {newsQueryVar.data.map((topic) => {
                return (
                  <div
                    style={{
                      color: "white",
                      fontSize: "30px",
                      textAlign: "center",
                      fontFamily: "indie flower",
                      fontWeight: "bold",
                      flex: phoneView ? "0 0 100%" : "0 0 50%",
                      minWidth: 0,
                      maxHeight: maxHeight,
                      height: maxHeight,
                      backgroundImage: `url(${topic.event_image})`,
                      backgroundSize: "cover",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        color: "black",
                        fontSize: "15px",
                        maxWidth:"50%",
                        margin:"auto",
                        marginTop:"5px",
                        padding:"1%",
                        backgroundColor: "rgba(255, 238, 195, 0.8)",
                        borderRadius: "5px",
                        textAlign: "center",
                        fontFamily: "indie flower",
                        fontWeight: "bold"
                      }}
                    >
                      {topic.title}
                    </div>
                    <div
                      style={{
                        color: "black",
                        fontSize: "15px",
                        margin:"3%",
                        padding:"2%",
                        backgroundColor: "rgba(255, 238, 195)",
                        borderRadius: "5px",
                        bottom: "0",
                        right:"0",
                        position: "absolute",
                        fontFamily: "indie flower",
                        fontWeight: "bold"
                        
                      }}
                      onClick={(e) => {
                        openState[1](true)
                        setSelectedTopic(topic)
                      }}
                    >
                      Lue lisää!
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <NewMobile openState={openState} event={selectedTopic}/>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default News;
